<template>
  <!-- Footer -->
  <footer class="footer">
    <!-- Footer Top -->
    <div class="footer-top aos" data-aos="fade-down">
      <div class="container">
        <div class="row">
          <div class="col-lg-7">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <!-- Footer Widget -->
                <div class="footer-widget footer-menu">
                  <h5 class="footer-title">عن الشركة</h5>
                  <ul>
                    <li>
                      <router-link to="/pages/about-us">عن شركتنا</router-link>
                    </li>
                    <li>
                      <a href="javascript:void(0)">تسوق تويوتا</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">دريمز رينتالز أمريكا</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">دريمز رينتالز حول العالم</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">فئة دريمز رينتال</a>
                    </li>
                  </ul>
                </div>
                <!-- /Footer Widget -->
              </div>
              <div class="col-lg-4 col-md-6">
                <!-- Footer Widget -->
                <div class="footer-widget footer-menu">
                  <h5 class="footer-title">أنواع المركبات</h5>
                  <ul>
                    <li>
                      <a href="javascript:void(0)">جميع المركبات</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">سيارات SUV</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">الشاحنات</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">السيارات</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">الكروس أوفر</a>
                    </li>
                  </ul>
                </div>
                <!-- /Footer Widget -->
              </div>
              <div class="col-lg-4 col-md-6">
                <!-- Footer Widget -->
                <div class="footer-widget footer-menu">
                  <h5 class="footer-title">روابط سريعة</h5>
                  <ul>
                    <li>
                      <a href="javascript:void(0)">حسابي</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">الحملات</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">وكلاء دريمز رينتال</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">العروض والحوافز</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">الخدمات المالية</a>
                    </li>
                  </ul>
                </div>
                <!-- /Footer Widget -->
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="footer-contact footer-widget">
              <h5 class="footer-title">معلومات الاتصال</h5>
              <div class="footer-contact-info">
                <div class="footer-address">
                  <span><i class="feather-phone-call"></i></span>
                  <div class="addr-info">
                    <a href="tel:+1(888)7601940">+ 1 (888) 760 1940</a>
                  </div>
                </div>
                <div class="footer-address">
                  <span><i class="feather-mail"></i></span>
                  <div class="addr-info">
                    <a href="mailto:support@example.com">support@example.com</a>
                  </div>
                </div>
                <div class="update-form">
                  <form action="javascript:;">
                    <span><i class="feather-mail"></i></span>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="أدخل بريدك الإلكتروني هنا"
                    />
                    <button type="submit" class="btn btn-subscribe">
                      <span><i class="feather-send"></i></span>
                    </button>
                  </form>
                </div>
              </div>
              <div class="footer-social-widget">
                <ul class="nav-social">
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fa-brands fa-facebook-f fa-facebook fi-icon"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fab fa-instagram fi-icon"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fab fa-behance fi-icon"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fab fa-twitter fi-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)"
                      ><i class="fab fa-linkedin fi-icon"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Footer Top -->

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <!-- Copyright -->
        <div class="copyright">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="copyright-text">
                <p>© {{ new Date().getFullYear() }} دريمز رينت. جميع الحقوق محفوظة.</p>
              </div>
            </div>
            <div class="col-md-6">
              <!-- Copyright Menu -->
              <div class="copyright-menu">
                <div class="vistors-details">
                  <ul class="d-flex">
                    <li>
                      <a href="javascript:void(0)"
                        ><img
                          class="img-fluid"
                          src="@/assets/img/icons/paypal.svg"
                          alt="باي بال"
                      /></a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                        ><img
                          class="img-fluid"
                          src="@/assets/img/icons/visa.svg"
                          alt="فيزا"
                      /></a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                        ><img
                          class="img-fluid"
                          src="@/assets/img/icons/master.svg"
                          alt="ماستر كارد"
                      /></a>
                    </li>
                    <li>
                      <a href="javascript:void(0)"
                        ><img
                          class="img-fluid"
                          src="@/assets/img/icons/applegpay.svg"
                          alt="أبل باي"
                      /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /Copyright Menu -->
            </div>
          </div>
        </div>
        <!-- /Copyright -->
      </div>
    </div>
    <!-- /Footer Bottom -->
  </footer>
  <!-- /Footer -->
</template>
<style scoped>
.footer{
  padding: 20px;
}
</style>